import { Component, OnInit, output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-whitelabel-ios-plist-upload',
  templateUrl: './whitelabel-ios-plist-upload.component.html',
  styleUrls: ['./whitelabel-ios-plist-upload.component.css']
})
export class WhitelabelIosPlistUploadComponent implements OnInit {

  public readonly errorEvent$ = output<void>();

  public readonly successEvent$ = output<File>();

  ngOnInit(): void {}

  public onPlistUpload(event: any): void {
    const files = event.target.files as FileList;
    const uploadedFile = files[0];

    if (uploadedFile) {
      if (uploadedFile.name !== 'GoogleService-Info.plist') {
        this.errorEvent$.emit();
        return;
      }

      this.successEvent$.emit(uploadedFile);
    }

    return;
  }
}
